import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Actions = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Actions' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M12,17.5 C15.0375661,17.5 17.5,15.0375661 17.5,12 C17.5,8.96243388 15.0375661,6.5 12,6.5 C8.96243388,6.5 6.5,8.96243388 6.5,12 C6.5,15.0375661 8.96243388,17.5 12,17.5 Z M12,6.5 L12,1 M12,23 L12,17.5 M1,12 L6.5,12 M17.5,12 L23,12 M4.4375,4.4375 L8.5625,8.5625 M15.4375,15.4375 L19.5625,19.5625 M19.5625,4.4375 L15.4375,8.5625 M8.5625,15.4375 L4.4375,19.5625' />
  </StyledIcon>
);
